import InfoIcon from '@mui/icons-material/Info';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface VersionInfoProps {
  versionInfo: {
    api: string;
    web: string;
  };
}

export const VersionInfo: React.FC<VersionInfoProps> = React.memo(({ versionInfo }) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ 
      mt: 'auto', 
      p: 2,
      borderTop: '1px solid rgba(0, 0, 0, 0.12)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      backgroundColor: 'rgba(0, 0, 0, 0.03)',
    }}>
      <Box sx={{ 
        display: 'flex',
        alignItems: 'center',
        mb: 1,
        color: 'text.secondary',
        fontSize: '0.75rem'
      }}>
        <InfoIcon fontSize="small" sx={{ mr: 0.5, fontSize: '0.875rem' }} />
        {t('system.version')}
      </Box>
      <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5 }}>
        API: {versionInfo.api}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        Web: {versionInfo.web}
      </Typography>
    </Box>
  );
});